import EA from 'helpers/init';

// Add method to <img> element, add your img path to "data-src", leave empty src (src="")
export default EA.Methods.imageLazyLoad = ($this) => {
    const imageEl = $this;
    let observer;

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                imageEl.src = imageEl.dataset.src;
                observer.disconnect();
            }
            // console.log(entry.isIntersecting);
        });
    }

    function createObserver() {
        const options = {
            root: null,
            rootMargin: '100px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(imageEl);
    }

    createObserver();
};

